import { useNavigate } from 'react-router';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';

export interface LeaderboardColumn<T> {
  header: string;
  cell: (row: T) => React.ReactNode;
  className?: string;
}

interface LeaderboardTableProps<T> {
  rows: T[];
  columns: LeaderboardColumn<T>[];
  getKey: (row: T) => string;
  getHref?: (row: T) => string;
  emptyLabel?: string;
}

export function LeaderboardTable<T>({
  rows,
  columns,
  getKey,
  getHref,
  emptyLabel = 'No data',
}: LeaderboardTableProps<T>) {
  const navigate = useNavigate();
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            {columns.map((c, i) => (
              <TableHead key={i} className={c.className}>
                {c.header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={columns.length}
                className="text-center text-muted-foreground"
              >
                {emptyLabel}
              </TableCell>
            </TableRow>
          ) : (
            rows.map((row) => {
              const href = getHref?.(row);
              return (
                <TableRow
                  key={getKey(row)}
                  className={href ? 'cursor-pointer hover:bg-accent' : undefined}
                  onClick={href ? () => navigate(href) : undefined}
                >
                  {columns.map((c, i) => (
                    <TableCell key={i} className={c.className}>
                      {c.cell(row)}
                    </TableCell>
                  ))}
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </div>
  );
}
